import { Navigate, Outlet, useParams } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext'; // your auth provider
import { useEffect, useState } from 'react';
//import { doc, getDoc } from 'firebase/firestore';
//import { db } from "../../services/firebase";
import { getLeagueBySlug } from "../leagueLocker/firestoreQuery";
import { decryptObject } from '../utils/crypto';
import StyledLoadingSpinner from '../ui/StyledLoadingSpinner';

const RESERVED_PATHS = [
    'home',
    'login',
    'signup',
    'forgot-password',
    'reset-password',
    'verify',
    'admin',
    'dashboard',
    'create-league',
    'edit-league',
    'punishments',
    'draft-ideas',
    'challenges',
    'articles',
    'about',
    'league',
    'yahoo-callback',
    'wheelofshame',
    'privacy-policy',
    'terms-of-service',
];

const LeagueLockerGuard = () => {
    const { leagueUrl } = useParams<{ leagueUrl: string }>();
    const { user, isLoading } = useAuth();
    const [requiresAuth, setRequiresAuth] = useState<boolean | null>(null);
    const [leagueFound, setLeagueFound] = useState<boolean>(true);
    const [actualLeagueSlug, setActualLeagueSlug] = useState(null);
    const [isEncodedReq, setIsEncodedReq] = useState(false);

    useEffect(() => {
        const checkLeaguePrivacy = async () => {
            if (!leagueUrl) return;
           
            let decoded = null;
            let leagueSlug = null;
            let isEncoded = false;

            try {
                decoded = decryptObject(leagueUrl);
                console.log('decoded value ', decoded);
                leagueSlug = decoded.slug ? decoded.slug : null;
                isEncoded = decoded.isEncoded ? decoded.isEncoded : false;
            } catch (err) {
                // case 1 tamperd url
                // case 2 lueague-slug 
                leagueSlug = leagueUrl
            }

            // Example: fetch league settings from Firestore
            setActualLeagueSlug(leagueSlug);
            setIsEncodedReq(isEncoded);
            const leagueData = await getLeagueBySlug(leagueSlug);
            if (leagueData) {
                const data = leagueData;
                if (data.isPublic) {
                    setRequiresAuth(false); // public view
                } else {
                    setRequiresAuth(true); //private view
                }
            } else {
                setLeagueFound(false);
            }
        };

        checkLeaguePrivacy();
    }, [leagueUrl]);

    // 🚨 If the param is one of the reserved routes → just render <Outlet /> so React Router uses the normal element
    if (leagueUrl && RESERVED_PATHS.includes(leagueUrl)) {
        return <Outlet />;
    }

    if (!leagueFound) {
        return <Navigate to="/" replace />;
    } else {
        if (requiresAuth === null || isLoading) return <StyledLoadingSpinner />;

        if (requiresAuth && !user) {
            console.log('requiresAuth', requiresAuth);
            return <Navigate to={`/home?token=${leagueUrl}`} replace />;
        }
    }



    return <Outlet context={{ leagueUrl: actualLeagueSlug, isEncodedReq }} />;
};

export default LeagueLockerGuard;
